import { render, staticRenderFns } from "./GraficoBarDashVisitas.vue?vue&type=template&id=238ff13f"
import script from "./GraficoBarDashVisitas.vue?vue&type=script&lang=js"
export * from "./GraficoBarDashVisitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports